<h1 mat-dialog-title>Exit without saving changes</h1>
<div mat-dialog-content>
    <div class="mt-3">
        If you don't click "Save Changes" you will exit editing mode without
        saving changes.
    </div>
    <div class="my-3">
        Are you sure you want to continue without saving changes?
    </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-between">
    <button mat-button [mat-dialog-close]="true">
        Yes, exit without saving
    </button>
    <button
        mat-raised-button
        [mat-dialog-close]="false"
        color="primary"
        cdkFocusInitial
    >
        No, back to edit
    </button>
</div>
